import { ChangeDetectionStrategy, Component, inject, input, linkedSignal } from '@angular/core';
import { SelectButtonModule } from '@openng/optimus-ui/selectbutton';
import { ToggleSwitchModule } from '@openng/optimus-ui/toggleswitch';
import { DatePickerModule } from '@openng/optimus-ui/datepicker';
import { toSignal } from '@angular/core/rxjs-interop';
import { SchedulerService } from '@zayan-erp/scheduler';
import { map } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { LotScheduleTaskLookupItem, TaskStatusEnum } from '../../../../../scheduler/src/index';
import { DatePipe } from '@angular/common';
import { CheckboxModule } from '@openng/optimus-ui/checkbox';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'lot-schedule-task-item',
  standalone: true,
  imports: [
    SelectButtonModule,
    ToggleSwitchModule,
    DatePickerModule,
    FormsModule,
    DatePipe,
    CheckboxModule,
    CommonModule
  ],
  templateUrl: './lot-schedule-task-item.component.html',
  styleUrl: './lot-schedule-task-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LotScheduleTaskItemComponent {
  TaskStatusEnum = TaskStatusEnum;

  #schedulerService = inject(SchedulerService);

  scheduleTaskItem = input.required<LotScheduleTaskLookupItem>();
  isSelected = input<boolean>(false);

  selectedTaskStatus = linkedSignal({
    source: () => ({ task: this.scheduleTaskItem() }),
    computation: source => source.task.status || TaskStatusEnum.NOT_STARTED
  });

  // all statuses except 'Not Started', 'Started', 'Active'
  taskStatusList = toSignal(
    this.#schedulerService.readScheduleTaskStatuses().pipe(
      map(statuses => statuses.map((status: string) => ({ label: status, value: status }))),
      map(statuses =>
        statuses.filter(
          (status: { label: string; value: string }) =>
            status.value !== TaskStatusEnum.NOT_STARTED &&
            status.value !== TaskStatusEnum.STARTED &&
            status.value !== TaskStatusEnum.ACTIVE
        )
      )
    ),
    { initialValue: [] }
  );
}
